var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.1806,
    cy: 18.1806,
    r: 18.1806,
    fill: "#D0DFEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8283 16.172C19.0782 15.4222 18.061 15.0009 17.0003 15.0009C15.9397 15.0009 14.9224 15.4222 14.1723 16.172L10.1723 20.172C9.79028 20.541 9.48556 20.9824 9.27592 21.4704C9.06628 21.9584 8.95594 22.4833 8.95132 23.0144C8.94671 23.5456 9.04791 24.0723 9.24904 24.5639C9.45016 25.0554 9.74717 25.5021 10.1227 25.8776C10.4983 26.2532 10.9449 26.5502 11.4365 26.7513C11.9281 26.9525 12.4548 27.0537 12.9859 27.049C13.517 27.0444 14.0419 26.9341 14.5299 26.7244C15.018 26.5148 15.4593 26.2101 15.8283 25.828L16.9303 24.727M16.1723 19.828C16.9224 20.5779 17.9397 20.9992 19.0003 20.9992C20.061 20.9992 21.0782 20.5779 21.8283 19.828L25.8283 15.828C26.557 15.0736 26.9601 14.0632 26.951 13.0144C26.9419 11.9656 26.5212 10.9624 25.7796 10.2208C25.038 9.47913 24.0347 9.05846 22.9859 9.04935C21.9371 9.04023 20.9267 9.44341 20.1723 10.172L19.0723 11.272",
    stroke: "#304659",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.9e0497aa.svg";
export { ForwardRef as ReactComponent };